var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _radialGradient, _radialGradient2, _radialGradient3, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _radialGradient4, _linearGradient20, _linearGradient21, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCryptowallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "48px",
    viewBox: "0 -1 511.99989 511",
    width: "48px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 260.0433992472,
    x2: 260.0433992472,
    xlinkHref: "#lg1",
    y1: 88.5279352538,
    y2: 181.7601635498
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b53759",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb5b0"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 265.7888448532,
    x2: 265.7888448532,
    xlinkHref: "#lg2",
    y1: 111.6000706578,
    y2: 253.2593879976
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    stopColor: "#fec33a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4454,
    stopColor: "#fbb840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6474,
    stopColor: "#f6a649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8426,
    stopColor: "#f08d56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97264"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 131.1897093706,
    x2: 422.5925263474,
    xlinkHref: "#lg3",
    y1: 146.2268463208,
    y2: 146.2268463208
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 263.0216342524,
    x2: 382.7793892402,
    y1: 119.5546466248,
    y2: 349.8582687206
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fca17a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#f69373",
    stopOpacity: 0.152941
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#ef816b",
    stopOpacity: 0.415686
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6926,
    stopColor: "#ea7666",
    stopOpacity: 0.694118
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97264"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e97264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 272.4083049524,
    x2: 258.2634455412,
    xlinkHref: "#lg4",
    y1: 191.6949756618,
    y2: 335.1639627988
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 248.032878008,
    x2: 204.3072560824,
    xlinkHref: "#lg4",
    y1: 199.0070415488,
    y2: 278.9788657156
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial0",
    cx: 235.2863,
    cy: 230.2035,
    gradientTransform: "matrix(1.003922 0 0 .897807 -.000107 -170.175363)",
    gradientUnits: "userSpaceOnUse",
    r: 273.6388,
    xlinkHref: "#lg3"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial1",
    cx: -4031.7952,
    cy: -3054.2578,
    gradientTransform: "matrix(-1.003922 0 0 -.897807 -3760.690303 -2578.193584)",
    gradientUnits: "userSpaceOnUse",
    r: 201.8128,
    xlinkHref: "#lg3"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial2",
    cx: 255.9519,
    cy: 263.8283,
    gradientTransform: "matrix(1.003922 0 0 .897807 -.000107 -170.175363)",
    gradientUnits: "userSpaceOnUse",
    r: 227.2047,
    xlinkHref: "#lg3"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 358.5216219542,
    x2: 206.8091300986,
    xlinkHref: "#lg4",
    y1: 191.4542351662,
    y2: 102.6310315098
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 291.1532353598,
    x2: 170.9789531342,
    y1: 114.666650799,
    y2: 179.2175303004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97264"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear8",
    gradientUnits: "userSpaceOnUse",
    x1: 285.1027982502,
    x2: 78.851942568,
    xlinkHref: "#lg4",
    y1: 275.2171699816,
    y2: 68.9663142994
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear9",
    gradientUnits: "userSpaceOnUse",
    x1: 272.2669527348,
    x2: 272.2669527348,
    xlinkHref: "#lg1",
    y1: 248.7467586076,
    y2: 546.2137664254
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear10",
    gradientUnits: "userSpaceOnUse",
    x1: 224.1785869738,
    x2: 333.1171749598,
    xlinkHref: "#lg2",
    y1: 206.3933976638,
    y2: 720.1525894
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear11",
    gradientUnits: "userSpaceOnUse",
    x1: 443.8748696098,
    x2: 560.29378081,
    xlinkHref: "#lg2",
    y1: 329.6110694324,
    y2: 446.0299806326
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear12",
    gradientUnits: "userSpaceOnUse",
    x1: 430.849082052,
    x2: 449.1102224476,
    y1: 291.9856791476,
    y2: 429.6473790834
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb5b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff70ac"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear13",
    gradientUnits: "userSpaceOnUse",
    x1: 272.2626358702,
    x2: 272.2626358702,
    xlinkHref: "#lg2",
    y1: 434.9882441234,
    y2: 523.1310898404
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear14",
    gradientUnits: "userSpaceOnUse",
    x1: 450.9227032264,
    x2: 374.4446280118,
    y1: 364.020295198,
    y2: 287.5422199834
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b395f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial3",
    cx: 397.5883430544,
    cy: 310.1495395014,
    gradientUnits: "userSpaceOnUse",
    r: 37.2029399072,
    xlinkHref: "#lg3"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear15",
    gradientUnits: "userSpaceOnUse",
    x1: 318.0183888642,
    x2: 121.2123309658,
    y1: 422.6907015844,
    y2: 225.884643686
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear16",
    gradientUnits: "userSpaceOnUse",
    x1: 91.797014797,
    x2: 266.7778084154,
    y1: 120.3999489488,
    y2: 285.324355501
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4139,
    stopColor: "#1fa999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f4a72"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m69.53125 162.707031c-5.441406 1.5-10.324219 4.148438-14.425781 7.632813h409.875v-74.355469c0-21.136719-20.121094-36.46875-40.5-30.867187zm0 0",
    fill: "url(#linear0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m70.480469 170.339844h394.5v-74.355469c0-21.136719-20.121094-36.472656-40.5-30.867187l-354.945313 97.589843c-.054687.015625-.109375.03125-.164062.046875-4.296875 1.203125-3.351563 7.585938 1.109375 7.585938zm0 0",
    fill: "url(#linear1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m422.59375 130.824219c0-71.960938-65.234375-130.296875-145.703125-130.296875s-145.699219 58.335937-145.699219 130.296875v30.804687c0 71.960938 65.230469 130.296875 145.699219 130.296875s145.703125-58.335937 145.703125-130.296875c0-.101562 0-30.703125 0-30.804687zm0 0",
    fill: "url(#linear2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m396.890625 56.917969c-26.285156-34.0625-70.222656-56.390625-120-56.390625s-93.714844 22.328125-120 56.390625v178.621093c26.285156 34.0625 70.222656 56.390626 120 56.390626s93.714844-22.328126 120-56.390626zm0 0",
    fill: "url(#linear3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m191.433594 267.160156c24.007812 15.578125 53.527344 24.769532 85.457031 24.769532 31.925781 0 61.449219-9.191407 85.457031-24.769532v-241.867187c-24.007812-15.574219-53.53125-24.769531-85.457031-24.769531-31.929687 0-61.449219 9.191406-85.457031 24.769531zm0 0",
    fill: "url(#linear4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m243.789062 288.546875c10.632813 2.210937 21.714844 3.378906 33.101563 3.378906s22.46875-1.167969 33.101563-3.378906v-284.640625c-10.632813-2.210938-21.714844-3.378906-33.101563-3.378906s-22.46875 1.167968-33.101563 3.378906zm0 0",
    fill: "url(#linear5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m422.59375 130.824219c0-71.960938-65.234375-130.296875-145.703125-130.296875s-145.699219 58.335937-145.699219 130.296875c0 71.964843 65.230469 130.300781 145.699219 130.300781s145.703125-58.335938 145.703125-130.300781zm0 0",
    fill: "url(#radial0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m406.34375 130.824219c0-63.933594-57.957031-115.765625-129.453125-115.765625-71.492187 0-129.449219 51.832031-129.449219 115.765625 0 63.9375 57.957032 115.769531 129.449219 115.769531 71.496094 0 129.453125-51.832031 129.453125-115.769531zm0 0",
    fill: "url(#radial1)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m394.082031 130.824219c0-57.878907-52.46875-104.800781-117.191406-104.800781s-117.191406 46.921874-117.191406 104.800781c0 57.882812 52.46875 104.804687 117.191406 104.804687s117.191406-46.921875 117.191406-104.804687zm0 0",
    fill: "url(#radial2)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m413.976562 175.054688-122.230468-121.085938c-.160156-1.570312-1.484375-2.792969-3.09375-2.792969h-11.367188c-1.714844 0-3.109375 1.394531-3.109375 3.109375v9.78125l-11.898437-10.097656c-.160156-1.570312-1.484375-2.792969-3.09375-2.792969h-11.363282c-1.71875 0-3.109374 1.390625-3.109374 3.109375v9.78125h-9.804688c-1.71875 0-3.109375 1.390625-3.109375 3.109375v10.0625c0 1.613281 1.222656 2.9375 2.792969 3.097657l10.121094 10.832031v82.429687h-9.804688c-1.71875 0-3.109375 1.394532-3.109375 3.109375v10.066407c0 1.609374 1.222656 2.933593 2.792969 3.09375l68.707031 69.113281c51.367187-8.40625 93.320313-40.90625 110.679687-83.925781zm0 0",
    fill: "url(#linear6)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m317.515625 131.625c-2.988281-4.304688-7.402344-7.601562-13.253906-9.898438 9.75-4.359374 14.628906-13.652343 14.628906-27.882812 0-11.128906-3.15625-18.871094-9.464844-23.234375-4.707031-3.25-10.597656-5.289063-17.664062-6.117187v-10.203126c0-1.71875-1.390625-3.113281-3.109375-3.113281h-11.363282c-1.71875 0-3.109374 1.394531-3.109374 3.113281v9.78125h-11.886719v-9.78125c0-1.71875-1.390625-3.113281-3.109375-3.113281h-11.363282c-1.71875 0-3.109374 1.394531-3.109374 3.113281v9.78125h-9.804688c-1.71875 0-3.109375 1.390626-3.109375 3.109376v10.0625c0 1.71875 1.390625 3.109374 3.109375 3.109374h9.804688v93.25h-9.804688c-1.71875 0-3.109375 1.390626-3.109375 3.109376v10.0625c0 1.71875 1.390625 3.109374 3.109375 3.109374h9.804688v9.78125c0 1.71875 1.390624 3.109376 3.109374 3.109376h11.363282c1.71875 0 3.109375-1.390626 3.109375-3.109376v-9.78125h11.886719v9.78125c0 1.71875 1.390624 3.109376 3.109374 3.109376h11.363282c1.71875 0 3.109375-1.390626 3.109375-3.109376v-9.933593c8.574219-.65625 15.554687-3.472657 20.933593-8.453125 6.195313-5.734375 9.292969-14.914063 9.292969-27.539063v-3.269531c0-8.257812-1.492187-14.542969-4.472656-18.84375zm-54.734375-51.378906h20.136719c11.816406 0 17.726562 5.507812 17.726562 16.523437 0 11.820313-5.792969 17.730469-17.382812 17.730469h-20.480469zm40.964844 72.117187c0 14.230469-6.484375 21.34375-19.449219 21.34375h-21.515625v-44.75h21.515625c6.421875 0 11.273437 1.605469 14.542969 4.820313 3.269531 3.210937 4.90625 8.492187 4.90625 15.832031zm0 0",
    fill: "url(#linear7)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m276.890625 291.929688c33.214844 0 63.828125-9.945313 88.335937-26.679688l-208.332031-208.332031c-16.207031 21-25.703125 46.460937-25.703125 73.90625v30.804687c-.003906 71.960938 65.230469 130.300782 145.699219 130.300782zm0 0",
    fill: "url(#linear8)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m502.746094 208.101562v263.910157c0 20.855469-16.90625 37.761719-37.761719 37.761719h-385.4375c-20.855469 0-37.761719-16.90625-37.761719-37.761719v-272.886719c0-11.359375 5.0625-21.773438 13.304688-28.785156h409.894531c20.855469 0 37.761719 16.90625 37.761719 37.761718zm0 0",
    fill: "url(#linear9)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m41.78125 206.804688h395.507812c16.730469 0 30.292969 12.488281 30.292969 27.894531v205.921875c0 15.40625-13.5625 27.898437-30.292969 27.898437h-395.507812zm0 0",
    fill: "url(#linear10)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m502.742188 472.011719v-199.34375c-1.53125-.570313-3.183594-.886719-4.914063-.886719h-126.710937c-7.828126 0-14.171876 6.34375-14.171876 14.171875v66.691406c0 4.6875 2.285157 8.832031 5.796876 11.414063l131.640624 131.636718c5.226563-6.476562 8.359376-14.710937 8.359376-23.683593zm0 0",
    fill: "url(#linear11)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m497.828125 366.816406h-126.710937c-7.828126 0-14.171876-6.34375-14.171876-14.171875v-66.691406c0-7.828125 6.34375-14.171875 14.171876-14.171875h126.710937c7.828125 0 14.171875 6.34375 14.171875 14.171875v66.691406c0 7.824219-6.34375 14.171875-14.171875 14.171875zm0 0",
    fill: "url(#linear12)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m41.78125 387.226562v84.785157c0 20.855469 16.90625 37.761719 37.761719 37.761719h385.4375c20.855469 0 37.761719-16.90625 37.761719-37.761719v-84.785157zm0 0",
    fill: "url(#linear13)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m428.183594 299.394531c-5.425782-5.992187-13.265625-9.753906-21.984375-9.753906-16.378907 0-29.65625 13.277344-29.65625 29.65625 0 8.71875 3.761719 16.558594 9.75 21.984375l25.535156 25.535156h83.78125zm0 0",
    fill: "url(#linear14)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m435.859375 319.296875c0 16.382813-13.277344 29.660156-29.660156 29.660156-16.378907 0-29.65625-13.277343-29.65625-29.660156 0-16.378906 13.277343-29.65625 29.65625-29.65625 16.382812 0 29.660156 13.277344 29.660156 29.65625zm0 0",
    fill: "url(#radial3)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m171.5625 183.761719c-6.855469 0-12.414062-5.558594-12.414062-12.417969v-.972656l.003906-.03125h-104.0625c-8.242188 7.011718-13.304688 17.425781-13.304688 28.785156v52.316406l258.332032 258.332032h164.867187c12.300781 0 23.222656-5.882813 30.117187-14.984376l-302.1875-302.183593c-5.660156-5.664063-13.339843-8.84375-21.351562-8.84375zm0 0",
    fill: "url(#linear15)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m158.90625 167.390625v-160.746094c0-6.894531-5.589844-6.117187-12.484375-6.117187h-99.34375c-6.894531 0-12.484375-.777344-12.484375 6.117187v160.746094c0 9.542969-7.734375 17.277344-17.277344 17.277344-15.398437 0-23.105468 18.613281-12.21875 29.5l79.433594 79.4375c6.75 6.746093 17.6875 6.746093 24.4375 0l79.433594-79.4375c10.886718-10.882813 3.179687-29.5-12.21875-29.5-9.542969 0-17.277344-7.734375-17.277344-17.277344zm0 0",
    fill: "url(#linear16)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptowallet);
export default __webpack_public_path__ + "static/media/cryptowallet.38d4ec72d312b8074eea21071fc5118f.svg";
export { ForwardRef as ReactComponent };